// Rotulos e links da ficha do produto por tipo de canal (adapter).
// wc: identico ao comportamento original. ml: id MLB sem prefixo WC e permalink do anuncio.
import type { ChannelAdapter } from "./types";

export const WC_SITE = "https://atacado.hiitfitwear.com";

export interface ChannelLinkInput {
  adapter: ChannelAdapter | string | null | undefined;
  externalId: string | number | null | undefined;
  /** permalink do anuncio (dados `ml` da ficha); so usado no adapter ml. */
  mlPermalink?: string | null;
}

export interface ChannelLinks {
  /** "WC#123" / "MLB123"; null quando nao ha id externo. */
  externalIdLabel: string | null;
  /** Botao "ver" do rodape; null quando nao ha destino. */
  viewUrl: string | null;
  viewLabel: string;
  viewLabelShort: string;
  /** Link do admin da plataforma (so wc), usado no erro. */
  adminUrl: string | null;
  adminLabel: string;
  publishTitle: string;
  republishTitle: string;
}

export function channelLinks(i: ChannelLinkInput): ChannelLinks {
  const id = i.externalId === null || i.externalId === undefined || i.externalId === "" ? null : String(i.externalId);
  if (i.adapter === "ml") {
    return {
      externalIdLabel: id,
      viewUrl: i.mlPermalink || null,
      viewLabel: "Ver no Mercado Livre",
      viewLabelShort: "ML",
      adminUrl: null,
      adminLabel: "",
      publishTitle: "Publicar no Mercado Livre",
      republishTitle: "Força sincronização com o Mercado Livre",
    };
  }
  return {
    externalIdLabel: id ? `WC#${id}` : null,
    viewUrl: id ? `${WC_SITE}/?p=${id}` : null,
    viewLabel: "Ver no WC",
    viewLabelShort: "WC",
    adminUrl: id ? `${WC_SITE}/wp-admin/post.php?post=${id}&action=edit` : null,
    adminLabel: "Ver no WP admin",
    publishTitle: "Publicar no WC",
    republishTitle: "Força sincronização com WC",
  };
}
